import React, { Component } from 'react'
import styled from 'styled-components'
import { Popconfirm, Button, Form, Select, Input, Collapse, Icon } from 'antd'
import moment from 'moment'
import ContactsCollapse from './Collapse'

const { Panel } = Collapse
const FormItem = Form.Item
const Option = Select.Option

const AddItemsContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`

class Emails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachmentDetailsVisible: false
    }
  }

  renderElement = email => {
    const { handleRowEmailClick } = this.props
    const { address, type, created_date } = email
    const createdDate = moment.utc(created_date).format('M/D/YYYY')
    return (
      <Panel key={address} header={address}>
        <div className="row">
          <div className="col-md-6">
            <div className="jobDetailsHeader">Address:</div>
            <span>{address}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Type:</div>
            <span>{type}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Created:</div>
            <span>{createdDate}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Edit:</div>
            <Button onClick={() => handleRowEmailClick(email)}>
              <Icon type="edit" />
            </Button>
          </div>
        </div>
      </Panel>
    )
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const {
      handleToggleEmailEditArea,
      currentEmailData,
      onChangeEmailType,
      onEmailInputChange,
      handleDeleteEmail,
      handleAddEditEmail,
      emailAddEditContainer
    } = this.props
    const emails = this.props.emails || []
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>E-mails</h4>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <Button icon="plus" onClick={handleToggleEmailEditArea} className="ml-2">
              {' '}
              Add E-mail
            </Button>
          </div>
        </div>
        {emailAddEditContainer && (
          <AddItemsContainer>
            <div className="row">
              <div className="col-md-6">
                <FormItem label="E-mail">
                  {getFieldDecorator('email_new', {
                    rules: [
                      {
                        required: false,
                        message: 'Mobile Number cannot be blank.'
                      }
                    ],
                    initialValue: currentEmailData ? currentEmailData.address : ''
                  })(<Input onChange={onEmailInputChange} />)}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Type">
                  {getFieldDecorator('type_new', {
                    rules: [
                      {
                        required: false,
                        message: 'You must choose a status'
                      }
                    ],
                    initialValue: currentEmailData ? currentEmailData.type : ''
                  })(
                    <Select
                      placeholder="Choose the type"
                      onChange={onChangeEmailType}
                      defaultValue={currentEmailData ? currentEmailData.type : ''}
                      style={{ width: '100%' }}
                    >
                      <Option value="Work">Work</Option>
                      <Option value="Personal">Personal</Option>
                    </Select>
                  )}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 d-flex justify-content-end">
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={handleDeleteEmail}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  {currentEmailData && <Button type="danger" icon="delete" className="mr-2" />}
                </Popconfirm>
                <Button onClick={handleAddEditEmail}>{currentEmailData ? 'Edit' : 'Add'}</Button>
              </div>
            </div>
          </AddItemsContainer>
        )}
        <ContactsCollapse emptyText="There are no emails for this contact">
          {emails.map(this.renderElement)}
        </ContactsCollapse>
      </div>
    )
  }
}

export default Form.create()(Emails)



// WEBPACK FOOTER //
// ./src/components/contacts/Emails.js